import { ActionType } from 'typesafe-actions';
import { v4 as uuidv4 } from 'uuid';

import * as actions from '../actions/requirementsNpaActions';
import { IRequirementsNpaState } from '../interfaces/IRequirementsNpaState';
import { RequirementsNpaActionsEnum } from '../enums/RequirementsNpaActionsEnum';
import { RequirementsModalModeEnum } from '../enums/RequirementsModalModeEnum';

export type RequirementsNpaAction = ActionType<typeof actions>;

const initialState: IRequirementsNpaState = {
  npaCount: 0,
  npaSource: null,
  selectedNpa: null,
  listNpa: [],
  isNpaCreated: false,
  isSuCreated: false,
  isNpaEdited: false,
  isNpaEditedWithError: false,
  isListNpaDirty: false,
  listStructuralUnit: [],
  isListStructuralUnitLoaded: false,
  selectedMandatory: [],
  isStructuralUnitCreated: false,
  createdSelectedStructuralUnits: [],
  listMandatory: {},
  isMandatoryCreated: false,
  formRef: null,
  modalMode: RequirementsModalModeEnum.SELECT_NPA,
  savedNpa: null,
  oivControlId: null,
  oivControlTypeId: null,
  notices: [],
  idMap: null,
  npaListNew: null,
  isNpaStructureChanged: false,
  activeDublicateNpa: null,
};

export function requirementsNpaReducer(state = initialState, action: RequirementsNpaAction) {
  switch (action.type) {
    case RequirementsNpaActionsEnum.SET_NPA_COUNT: {
      return {
        ...state,
        npaCount: action.payload.count,
      };
    }
    case RequirementsNpaActionsEnum.SET_NPA_SOURCE: {
      return {
        ...state,
        npaSource: action.payload.source,
      };
    }
    case RequirementsNpaActionsEnum.SET_NPA_LIST_NEW: {
      return {
        ...state,
        npaListNew: action.payload.data,
      };
    }
    case RequirementsNpaActionsEnum.SET_CURRENT_NPA: {
      return {
        ...state,
        activeDublicateNpa: action.payload.data,
      };
    }
    case RequirementsNpaActionsEnum.SET_FORM_REF: {
      return {
        ...state,
        formRef: action.payload.formRef,
      };
    }
    case RequirementsNpaActionsEnum.SET_NPA_LIST: {
      return {
        ...state,
        listNpa: action.payload.data,
      };
    }
    case RequirementsNpaActionsEnum.SET_MODAL_MODE: {
      return {
        ...state,
        modalMode: action.payload.mode,
      };
    }
    case RequirementsNpaActionsEnum.SET_SELECTED_NPA: {
      return {
        ...state,
        selectedNpa: action.payload.npa,
      };
    }
    case RequirementsNpaActionsEnum.SET_STRUCTURAL_UNIT_LIST: {
      return {
        ...state,
        listStructuralUnit: action.payload.data,
      };
    }
    case RequirementsNpaActionsEnum.ADD_TO_STRUCTURAL_UNIT_LIST: {
      return {
        ...state,
        listStructuralUnit: [...state.listStructuralUnit, ...action.payload.units],
      };
    }
    case RequirementsNpaActionsEnum.ADD_SELECTED_MANDATORY: {
      return {
        ...state,
        selectedMandatory: [...state.selectedMandatory, action.payload.mandatory],
      };
    }
    case RequirementsNpaActionsEnum.SET_MANDATORY_LIST: {
      return {
        ...state,
        listMandatory: {
          ...state.listMandatory,
          [action.payload.suId]: action.payload.data,
        },
      };
    }
    case RequirementsNpaActionsEnum.SET_SELECTED_MANDATORY: {
      return {
        ...state,
        selectedMandatory: action.payload.mandatory,
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_MANDATORY_CREATED: {
      return {
        ...state,
        isMandatoryCreated: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.RESET_MODAL_LISTS: {
      return {
        ...state,
        selectedNpa: null,
        selectedMandatory: [],
        listNpa: [],
        listStructuralUnit: [],
        listMandatory: {},
        isMandatoryCreated: false,
      };
    }
    case RequirementsNpaActionsEnum.SET_SAVED_NPA: {
      return {
        ...state,
        savedNpa: action.payload.npa,
      };
    }
    case RequirementsNpaActionsEnum.SET_OIV_CONTROL_TYPE_ID: {
      return {
        ...state,
        oivControlTypeId: action.payload.id,
      };
    }
    case RequirementsNpaActionsEnum.SET_OIV_CONTROL_ID: {
      return {
        ...state,
        oivControlId: action.payload.id,
      };
    }
    case RequirementsNpaActionsEnum.ADD_NPA_MODAL_NOTICE: {
      const { notice } = action.payload;

      return {
        ...state,
        notices: [...state.notices, { ...notice, id: notice.id || uuidv4() }],
      };
    }
    case RequirementsNpaActionsEnum.REMOVE_NPA_MODAL_NOTICE: {
      const { id } = action.payload;

      return {
        ...state,
        notices: state.notices.filter(notice => notice.id !== id),
      };
    }
    case RequirementsNpaActionsEnum.REMOVE_ALL_NPA_MODAL_NOTICES: {
      return {
        ...state,
        notices: [],
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_NPA_CREATED: {
      return {
        ...state,
        isNpaCreated: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_SU_CREATED: {
      return {
        ...state,
        isSuCreated: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_NPA_EDITED: {
      return {
        ...state,
        isNpaEdited: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_NPA_EDITED_WITH_ERROR: {
      return {
        ...state,
        isNpaEditedWithError: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_STRUCTURAL_UNIT_CREATED: {
      return {
        ...state,
        isStructuralUnitCreated: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_NPA_LIST_DIRTY: {
      return {
        ...state,
        isListNpaDirty: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_LIST_STRUCTURAL_UNIT_LOADED: {
      return {
        ...state,
        isListStructuralUnitLoaded: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.SET_CREATED_SELECTED_STRUCTURAL_UNITS: {
      return {
        ...state,
        createdSelectedStructuralUnits: action.payload.units,
      };
    }
    case RequirementsNpaActionsEnum.SET_ID_MAP: {
      return {
        ...state,
        idMap: action.payload.value,
      };
    }
    case RequirementsNpaActionsEnum.SET_IS_NPA_STRUCTURE_CHANGED: {
      return { ...state, isNpaStructureChanged: action.payload };
    }
    default:
      return state;
  }
}
